import axios from 'axios';
import dayjs from 'dayjs';
import { API_URL } from '../../config';
import * as ActionTypes from './Actiontype';

export const GetTransaction = (payload, startdate, enddate) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.GET_TRANSACTION_INIT,
    });

    const token = localStorage.getItem('authToken');
    try {
      const res = await axios.post(
        `${API_URL}/api/transactions/fetch`,
        {
          search: payload,
          startDate: startdate,
          endDate: enddate,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data) {
        dispatch({
          type: ActionTypes.GET_TRANSACTION_SUCCESS,
          payload: res?.data,
        });
      } else {
        dispatch({
          type: ActionTypes.GET_TRANSACTION_FAIL,
          payload: res.data.message || 'Task data not get!',
        });
      }
    } catch (e) {
      dispatch({
        type: ActionTypes.GET_TRANSACTION_FAIL,
        payload: typeof e === 'string' ? e : '',
      });
    }
  };
};

export const getSingleTransaction = (userid, payload, startdate, enddate) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.GET_SINGLE_TRANSACTION_INIT,
    });

    const token = localStorage.getItem('authToken');
    try {
      const res = await axios.post(
        `${API_URL}/api/transactions/user`,
        {
          userId: userid,
          search: payload,
          startDate: startdate,
          endDate: enddate,
        },
        {
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Headers': '*',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (res.data) {
        dispatch({
          type: ActionTypes.GET_SINGLE_TRANSACTION_SUCCESS,
          payload: res?.data,
        });
      } else {
        dispatch({
          type: ActionTypes.GET_SINGLE_TRANSACTION_FAIL,
          payload: res.data.message || 'Task data not get!',
        });
      }
    } catch (e) {
      dispatch({
        type: ActionTypes.GET_SINGLE_TRANSACTION_FAIL,
        payload: typeof e === 'string' ? e : '',
      });
    }
  };
};
